import {
  Button,
  FormControlLabel,
  FormGroup,
  Switch,
  Tooltip,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import { useDetails } from "../../contexts/DetailsContext";
import * as Yup from "yup";
import EditIcon from "@mui/icons-material/Edit";

import {
  baseUrl,
  changeCheckingInfo,
  getBookingInfo,
  getCurrentUser,
  getEmptyRoomNumber,
  getRoomInformationData,
  getRoomRatePlan,
  getRoomType,
} from "../../api-config/config";
import {
  formateDateInApiSupport,
  isEqualOrAfter,
} from "../../utils/formatTime";
import DateRangeComponent from "../DateRangePicker";
import moment from "moment";
import {
  changeBookingStatus,
  insertPaymentData,
} from "../../api-config/payment.api";
import { calNoOfNights } from "../../utils/formatNumber";
import { calcDiscountValue, findRoomInfoAndSetPrice } from "./util.func";
import {
  getCorporateData,
  getTravelAgentData,
} from "../../api-config/user.api";
import { useNavigate } from "react-router-dom";
import "./EditForm.css";

const DemoEdit = (props: any) => {
  const {
    selectedEventInfo,
    handleCloseEditReservationDialog,
    selectedRoomInfo,
    resourceMap,
    onFormSubmitted,
    getRoomtypeId,
    bookedRooms,
    calendarInfo,
    roomTypeList1,
  } = props;

  const [roomInfo, setRoomInfo] = useState({} as any);
  const [pricePerRoom, setPricePerRoom] = useState(0);
  const [bookingId, setBookingId] = useState("");
  const [bookingInfo, setBookingInfo] = useState({} as any);
  const [submitButtonType, setSubmitButtonType] = useState("");
  const [range, setRange] = useState({
    startDate: selectedEventInfo.event.start,
    endDate: selectedEventInfo.event.end,
    key: "selection",
  });

  const [noOfAdult, setNoOfAdult] = useState(
    selectedEventInfo.event._def.extendedProps.guestBasicInfo.no_of_adults,
  );
  const [noOfChild, setNoOfChild] = useState(
    selectedEventInfo.event._def.extendedProps.guestBasicInfo.no_of_children,
  );

  const [roomTypeList, setRoomTypeList] = useState([] as any);
  const [roomList, setRoomList] = useState([] as any);
  const [emptyRoom, setEmptyRoom] = useState([] as any);
  const [selectedRoom, setSelectedRoom] = useState({
    id: selectedEventInfo.event._def.extendedProps.guestBasicInfo.room_id,
  } as any);
  const [selectedRoomType, setSelectedRoomType] = useState({
    id: selectedEventInfo.event._def.extendedProps.guestBasicInfo.room_type_id,
  } as any);

  const initBookingData =
    selectedEventInfo?.event?._def?.extendedProps?.guestBasicInfo;
  const [originalPrice, setOriginalPrice] = useState(
    initBookingData.total_sale_amount,
  );

  const [calculatedPrice, setCalcualtedPrice] = useState({
    total_price_with_tax: initBookingData.gross_amount,
    total_sale_price: initBookingData.total_sale_amount,
    room_service_charge: initBookingData.total_service_amount,
    service_charge_in_percentage:
      (initBookingData.service_amount / initBookingData.total_sale_amount) *
      100,
    discountMethod: initBookingData.discount_type,
    partialPayment: initBookingData.paid_amount,
    discountValue: calcDiscountValue(selectedEventInfo),
    discountAmount: initBookingData.discount_value,
    total_without_service:
      initBookingData.total_sale_amount - initBookingData.discount_value,
    total_without_tax: initBookingData.total_without_tax,
    total_tax: initBookingData.gross_amount - initBookingData.total_without_tax,
  } as any);

  const [isUpdateDisable, setIsUpdateDisable] = useState(true);
  const [roomInfoBasedOnAdult, setRoomInfoBasedOnAdult] = useState({} as any);
  const [isOpen, setIsOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [rateType, setRateType] = useState("");
  const [selectedRoomPlan, setSelectedRoomPlan] = useState({} as any);
  const [roomRatePlan, setRoomRatePlan] = useState<
    { id: number; name: string; [key: string]: any }[]
  >([]);
  const [marketSegment, setMarketSegment] = useState("");
  const [data, setData] = useState([]);
  const [selectedCorporate, setSelectedCorporate] = useState(0);
  const [checked, setChecked] = useState(
    calculatedPrice.total_tax > 0 ? true : false,
  );
  const [roomSelectionError, setRoomSelectionError] = useState("");
  const [needsPriceRecalculation, setNeedsPriceRecalculation] = useState(false);
  const [priceCalculationTrigger, setPriceCalculationTrigger] = useState(0);
  const [initialValuesSet, setInitialValuesSet] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event.target.checked, "this is checked");

    setChecked(event.target.checked);

    if (event.target.checked) {
      const basePrice = calculatedPrice.total_without_tax;
      const taxRate = basePrice <= 7500 ? 0.05 : 0.18;
      const taxAmount = basePrice * taxRate;

      setCalcualtedPrice((prev: any) => ({
        ...prev,
        total_tax: taxAmount,
        total_price_with_tax: basePrice + taxAmount,
      }));
    } else {
      setCalcualtedPrice((prev: any) => ({
        ...prev,
        total_tax: 0,
        total_price_with_tax: prev.total_without_tax,
      }));
    }
  };
  const navigate = useNavigate();

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setReason("");
    setError("");
  };

  const handleSubmitCashierData = async (cause: string) => {
    const payload = {
      booking_status: "no_show",
      booking_id: bookingInfo.booking_id,
      no_show_reason: cause,
    };

    await changeBookingStatus(payload).then((response: any) => {
      console.log(response);
    });
    window.location.reload();
  };

  const handleReasonChange = (e: any) => {
    setReason(e.target.value);
    if (e.target.value.trim() === "") {
      setError("Reason is required.");
    } else {
      setError("");
    }
  };
  const fetchSegmentData = (e: any) => {
    setMarketSegment(e.target.value);
    switch (e.target.value) {
      case "Corporate":
        return getCorporateData(loggedUser?.hotel_code, 0).then((res) =>
          setData(res.data),
        );
      case "Travel Agent":
        return getTravelAgentData(loggedUser?.hotel_code, 0).then((res) =>
          setData(res.data),
        );
      default:
        return;
    }
  };
  const handleConfirm = () => {
    if (reason.trim() === "") {
      setError("Reason is required.");
    } else {
      handleSubmitCashierData(reason);
      closeModal();
    }
  };

  const loggedUser = getCurrentUser();
  function getAndSetBookingInfo(booking_id: any) {
    getBookingInfo(Number(booking_id)).then((response: any) => {
      setBookingInfo({ ...response });
    });
  }

  function onFolioClick() {
    navigate("/main/folio", {
      state: {
        booking_id: selectedEventInfo.event._def.title.split("_")[0],
      },
    });
    handleCloseEditReservationDialog();
  }

  const defaultValues = {
    room_type: "",
    firstName: selectedEventInfo.event._def.extendedProps.guestBasicInfo.fName,
    lastName: selectedEventInfo.event._def.extendedProps.guestBasicInfo.lName,
    email: selectedEventInfo.event._def.extendedProps.guestBasicInfo.email,
    mobileNumber:
      selectedEventInfo.event._def.extendedProps.guestBasicInfo.mobile,
    price: calculatedPrice.total_without_service,
    discountMethod: calculatedPrice.discountMethod,
    discountValue: calculatedPrice.discountValue,
    partialPaymentMethod: bookingInfo?.payment_list?.[0]?.mode.toUpperCase(),
    partialPayment: calculatedPrice.partialPayment,
    firstName2:
      selectedEventInfo.event._def.extendedProps.guestBasicInfo
        .otherGuestInfo[0]?.first_name || "",
    firstName3:
      selectedEventInfo.event._def.extendedProps.guestBasicInfo
        .otherGuestInfo[1]?.first_name || "",
    lastName2:
      selectedEventInfo.event._def.extendedProps.guestBasicInfo
        .otherGuestInfo[0]?.last_name || "",
    lastName3:
      selectedEventInfo.event._def.extendedProps.guestBasicInfo
        .otherGuestInfo[1]?.last_name || "",
    rateType: bookingInfo?.rete_plan_name?.split(" ")?.[0],
    rate_plan_id: bookingInfo?.room_booking?.[0]?.rate_plan_id,
  };

  const handleSubmit = (formData: any, { setSubmitting }: any) => {
    if (needsPriceRecalculation) {
      //prices need recalculation, don't submit the form
      setSubmitting(false);
      return;
    }

    if (!selectedRoom.id) {
      setRoomSelectionError("Please select a room.");
      setSubmitting(false);
      return;
    } else {
      setRoomSelectionError("");
    }

    let receiptLink = "";
    console.log(marketSegment);
    console.log(formData, "this is form data before payload");

    if (submitButtonType === "cancelReservation") {
      const userResponse = window.prompt(
        "Do you want to continue for Cancellation? (Yes/No)",
      );
      if (userResponse !== null) {
        const normalizedResponse = userResponse.trim().toLowerCase();
        if (normalizedResponse === "yes") {
          bookingInfo.room_type_id = roomInfo.room_type_id;
          bookingInfo.booking_status = "cancelled";
          receiptLink = `${baseUrl}/booking_pdf_pms?booking_id=${bookingInfo.booking_id}&customer_id=${bookingInfo.customer_id}`;
        } else if (normalizedResponse === "no") {
          return;
        } else {
          return;
        }
      }
    } else if (
      submitButtonType === "update" ||
      submitButtonType === "checkin"
    ) {
      const other_members = [];
      if (noOfAdult >= 2) {
        if (formData.firstName2) {
          const obj1: any = {
            first_name: formData.firstName2,
            last_name: formData.lastName2,
          };
          if (bookingInfo.other_members?.length) {
            obj1.extra_guest_id = bookingInfo.other_members[0].extra_guest_id;
          }
          other_members.push(obj1);
        }
        if (formData.firstName3 && noOfAdult >= 3) {
          const obj2: any = {
            first_name: formData.firstName3,
            last_name: formData.lastName3,
          };
          if (bookingInfo.other_members?.length === 2) {
            obj2.extra_guest_id = bookingInfo.other_members[1].extra_guest_id;
          }
          other_members.push(obj2);
        } else if (formData.firstName3 && noOfAdult === 2) {
          const obj = {
            extra_guest_id: bookingInfo.other_members[1].extra_guest_id,
          };
          other_members.push(obj);
        }
      }
      if (noOfAdult === 1) {
        if (bookingInfo.other_members?.length) {
          bookingInfo.other_members.forEach((member: any) => {
            const obj = {
              extra_guest_id: member.extra_guest_id,
            };
            other_members.push(obj);
          });
        }
      }
      bookingInfo.other_members = other_members;
      bookingInfo.room_type_id = selectedRoomType.id;
      bookingInfo.first_name = formData.firstName;
      bookingInfo.last_name = formData.lastName;
      bookingInfo.email = formData.email;

      bookingInfo.mobile_number = formData.mobileNumber;
      bookingInfo.from_date = formateDateInApiSupport(range.startDate);
      bookingInfo.to_date = formateDateInApiSupport(range.endDate);
      bookingInfo.total_sale_amount = calculatedPrice.total_sale_price;
      (bookingInfo.total_services_amount = calculatedPrice.room_service_charge),
        (bookingInfo.service_charge =
          calculatedPrice.service_charge_in_percentage),
        (bookingInfo.total_without_tax = calculatedPrice.total_without_tax);
      bookingInfo.tax_amount = calculatedPrice.total_tax;
      bookingInfo.gross_amount = calculatedPrice.total_price_with_tax;
      bookingInfo.balance_amount =
        calculatedPrice.total_price_with_tax - formData.partialPayment;
      bookingInfo.paid_amount = formData.partialPayment;
      if (formData.discountMethod && calculatedPrice?.discountAmount) {
        bookingInfo.discount_value = formData.discountValue;
        bookingInfo.discount_type = formData.discountMethod;
      }
      bookingInfo.discount_amount = calculatedPrice?.discountAmount || 0;
      bookingInfo.rate_plan_id =
        selectedRoomPlan.id || bookingInfo?.room_booking?.[0]?.rate_plan_id;
      bookingInfo.rate_plan_amount =
        selectedRoomPlan.rate_amount ||
        bookingInfo?.room_booking?.[0]?.rate_plan_amount;
      bookingInfo.corporate_id = selectedCorporate || 0;
      bookingInfo.rete_plan_name = selectedRoomPlan.name || rateType;
      bookingInfo.market_segment = marketSegment;

      const roomAssignedAdultInfo = [
        {
          no_of_adults: noOfAdult,
          no_of_child: noOfChild,
          no_of_rooms: 1,
          room_id: selectedRoom.id,
        },
      ];
      bookingInfo.room_assinged_adult_info = roomAssignedAdultInfo;

      const roomBooking = [
        {
          room_id: selectedRoom.id,
          no_of_pax: noOfAdult + noOfChild,
          no_of_adults: noOfAdult,
          no_of_children: 0,
          no_of_rooms: 1,
          total_sale_amount: calculatedPrice.total_sale_price,
          discount_amount: calculatedPrice?.discountAmount || 0,
          coupon_amount: 0,
          total_without_tax: calculatedPrice.total_sale_price,
          tax_amount: "0",
          gross_amount: calculatedPrice.total_price_with_tax,
          rate_plan_id:
            selectedRoomPlan.id || bookingInfo?.room_booking?.[0]?.rate_plan_id,
          rate_plan_amount:
            selectedRoomPlan.rate_amount ||
            bookingInfo?.room_booking?.[0]?.rate_plan_amount,
        },
      ];
      bookingInfo.room_booking = roomBooking;

      receiptLink = `${baseUrl}/booking_pdf_pms?booking_id=${bookingInfo.booking_id}&customer_id=${bookingInfo.customer_id}`;
      if (submitButtonType === "checkin") {
        bookingInfo.check_in_time = moment().format("YYYY-MM-DD HH:mm:ss");
        bookingInfo.room_type_id = selectedRoomType.id;
        bookingInfo.booking_status = "check_in";
        receiptLink = `${baseUrl}/booking_pdf_pms?booking_id=${bookingInfo.booking_id}&customer_id=${bookingInfo.customer_id}`;
      }
    }

    changeCheckingInfo(bookingInfo).then((response: any) => {
      if (formData.partialPayment && formData.partialPaymentMethod) {
        const body = {
          booking_id:
            "this implementation is wrong need to think something else",
          paid_amount: formData.partialPayment,
          gross_amount: calculatedPrice.total_price_with_tax,
        } as any;
        if (formData.partialPaymentMethod === "UPI") {
          body.upi = formData.partialPayment;
        } else if (formData.partialPaymentMethod === "CASH") {
          body.cash = formData.partialPayment;
        } else if (formData.partialPaymentMethod === "CARD") {
          body.card = formData.partialPayment;
        } else if (formData.partialPaymentMethod === "ONLINE") {
          body.online = formData.partialPayment;
        }
        insertPaymentData(body);
      }
      if (response?.data?.room_booking?.length > 0) {
        const payload = {
          first_name: response.data?.first_name,
          checkinDate: response.data?.from_date,
          checkoutDate: response.data?.to_date,
          roomType: response.data?.room_booking[0]?.room_title,
          roomNo: response.data?.room_booking[0]?.room_id,
          totalPrice: response.data?.gross_amount,
          receiptLink: receiptLink,
          from_name: response.data?.hotel_name,
          reply_to: "booking@ratebotai.com",
          to_email: response.data?.email,
        };
      }
      onFormSubmitted(response);
    });
  };

  const handleOnchangePlan = (name: any) => {
    const match: any = roomRatePlan.find((plan: any) => plan.name === name);

    if (match) {
      setRateType(match?.name);
      setSelectedRoomPlan(match);
      // Set flag that prices need recalculation when rate plan changes
      if (initialValuesSet) {
        setNeedsPriceRecalculation(true);
      }
    }
  };
  // function onNoOfAdultlChange(value: any, discountObj?: any, str: any = "") {
  //   let child = 0;
  //   let adult = 0;
  //   setRateType("");
  //   if (str === "child") {
  //     child = Number(value);
  //     setNoOfChild(child);
  //   } else {
  //     adult = Number(value);
  //     setNoOfAdult(value);
  //   }
  //   const payload = {
  //     hotel_code: loggedUser?.hotel_code,
  //     start_date: formateDateInApiSupport(range.startDate),
  //     end_date: formateDateInApiSupport(range.endDate),
  //     room_info: [
  //       {
  //         number_of_adults: +adult,
  //         number_of_children: child,
  //         number_of_children_0_6: 0,
  //         number_of_children_6_12: 0,
  //       },
  //     ],
  //   };
  //   getRoomInformationData(payload).then((roomInformationData: any) => {
  //     setRoomInfoBasedOnAdult(roomInformationData.data);
  //   });
  // }
  // function onRoomTypeSelected(id: any) {
  //   console.log("calling on selected room type id from form", id);

  //   roomTypeList?.forEach((roomType: any) => {
  //     if (Number(id) === roomType.id) {
  //       setSelectedRoomType(roomType);
  //       setRoomList([...roomType.rooms]);

  //       if (selectedRoomType.id !== roomType.id) {
  //         setSelectedRoom({ id: "" });
  //       } else {
  //         setSelectedRoom(selectedRoom);
  //       }

  //       const payload = {
  //         hotel_code: loggedUser?.hotel_code,
  //         start_date: formateDateInApiSupport(range.startDate),
  //         end_date: formateDateInApiSupport(range.endDate),
  //         room_info: [
  //           {
  //             number_of_adults: +noOfAdult,
  //             number_of_children: +noOfChild,
  //             number_of_children_0_6: 0,
  //             number_of_children_6_12: 0,
  //           },
  //         ],
  //       };
  //       getRoomInformationData(payload).then((roomInformationData: any) => {
  //         setRoomInfoBasedOnAdult(roomInformationData.data);
  //       });

  //       getRoomRatePlan({
  //         hotel_code: loggedUser?.hotel_code,
  //         room_type_id: Number(id),
  //       }).then((response) => {
  //         setRoomRatePlan(response?.data);
  //       });
  //     }
  //   });
  // }

  function onNoOfAdultlChange(value: any, discountObj?: any, str: any = "") {
    let child = noOfChild;
    let adult = noOfAdult;
    if (str === "child") {
      child = Number(value);
      setNoOfChild(child);
    } else {
      adult = Number(value);
      setNoOfAdult(adult);
    }
    if (initialValuesSet) {
      setNeedsPriceRecalculation(true);
    }
    const payload = {
      hotel_code: loggedUser?.hotel_code,
      start_date: formateDateInApiSupport(range.startDate),
      end_date: formateDateInApiSupport(range.endDate),
      room_info: [
        {
          number_of_adults: str === "child" ? adult : Number(value),
          number_of_children: str === "child" ? Number(value) : child,
          number_of_children_0_6: 0,
          number_of_children_6_12: 0,
        },
      ],
    };
    getRoomInformationData(payload).then((roomInformationData: any) => {
      setRoomInfoBasedOnAdult(roomInformationData.data);
    });
  }

  function onRoomTypeSelected(id: any) {
    console.log("calling on selected room type id from form", id);

    if (initialValuesSet) {
      setNeedsPriceRecalculation(true);
    }

    roomTypeList?.forEach((roomType: any) => {
      if (Number(id) === roomType.id) {
        setSelectedRoomType(roomType);
        setRoomList([...roomType.rooms]);

        if (selectedRoomType.id !== roomType.id) {
          setSelectedRoom({ id: "" });
        } else {
          setSelectedRoom(selectedRoom);
        }

        const payload = {
          hotel_code: loggedUser?.hotel_code,
          start_date: formateDateInApiSupport(range.startDate),
          end_date: formateDateInApiSupport(range.endDate),
          room_info: [
            {
              number_of_adults: +noOfAdult,
              number_of_children: +noOfChild,
              number_of_children_0_6: 0,
              number_of_children_6_12: 0,
            },
          ],
        };
        getRoomInformationData(payload).then((roomInformationData: any) => {
          setRoomInfoBasedOnAdult(roomInformationData.data);
        });

        getRoomRatePlan({
          hotel_code: loggedUser?.hotel_code,
          room_type_id: Number(id),
        }).then((response) => {
          setRoomRatePlan(response?.data);
        });
      }
    });
  }

  function onRoomSelected(id: any) {
    emptyRoom?.forEach((room: any) => {
      if (room.id === Number(id)) {
        setSelectedRoom(room);
        setIsUpdateDisable(false);
      }
    });
  }
  const formValidation = Yup.object().shape({
    // room_type: Yup.string().required("Please enter room type"),
    firstName: Yup.string().required("Please enter First name"),
    // adult: Yup.number().required("Please enter Base Occupancy"),
    // rateType: Yup.string().required("Please select rate plan"),
    // child: Yup.string().required("Please enter State"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Please enter your email"),
    mobileNumber: Yup.string()
      .required("Please enter your mobile number")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
  });

  function onSetRange(value: any) {
    if (moment(value.endDate).isBefore(value.startDate, "day")) {
      value.startDate = moment(value.endDate).toDate();
      value.endDate = moment(value.startDate).add(1, "days").toDate();
    }
    // Prevent same-day booking
    if (moment(value.startDate).isSame(value.endDate, "day")) {
      // Set end date to next day
      value.endDate = moment(value.startDate).add(1, "days").toDate();

      const alertDiv = document.createElement("div");
      alertDiv.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        color: #1976d2;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0,0,0,0.15);
        z-index: 9999;
        animation: slideIn 0.3s ease-out;
        border: 2px solid white;
        font-weight: 500;
        min-width: 300px;
        text-align: center;
      `;

      alertDiv.innerHTML = `
        <div style="margin-bottom: 15px;">
          <svg width="40" height="40" viewBox="0 0 24 24" style="margin: 0 auto; display: block;">
            <path fill="#1976d2" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
        </div>
        <div style="font-size: 16px;">
          Same day bookings are not allowed.<br>End date has been set to next day.
        </div>
        <button style="
          margin-top: 15px;
          background: #1976d2;
          color: white;
          border: none;
          padding: 8px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-weight: 500;
          transition: background 0.2s;
        " onclick="this.parentElement.remove()">
          Understood
        </button>
      `;

      document.body.appendChild(alertDiv);

      // Add animation keyframes
      const style = document.createElement("style");
      style.textContent = `
        @keyframes slideIn {
          from { opacity: 0; transform: translate(-50%, -60%); }
          to { opacity: 1; transform: translate(-50%, -50%); }
        }
        button:hover {
          background: #1565c0 !important;
        }
      `;
      document.head.appendChild(style);

      setTimeout(() => {
        alertDiv.remove();
      }, 3000);
    }
    setRange(value);
    if (initialValuesSet) {
      setNeedsPriceRecalculation(true);
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialValuesSet(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleCorporateChange = (event: any) => {
    console.log(event.target.value, "this event on change co");
    setSelectedCorporate(event.target.value);
  };

  const getRoomTypeList = (hotel_code: number, floor_id: number) => {
    return getRoomType(hotel_code, floor_id).then(
      (res: any) => {
        if (res?.status_message === "success") {
          const roomTypeArray = [] as any;
          res.data?.forEach((roomType: any) => {
            const obj = {
              id: roomType.id,
              room_type_name: roomType.room_type_name,
              rooms: roomType.rooms,
              price: roomType.price,
              higher_occupancy: roomType.higher_occupancy,
              base_occupancy: roomType.base_occupan,
            };
            roomTypeArray.push(obj);
          });
          setRoomTypeList([...roomTypeArray]);
          console.log(res);
        } else {
          console.log(res.message);
        }
      },
      (error: any) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        console.log("error", resMessage);
      },
    );
  };

  const handleCalculateAndUpdate = () => {
    if (needsPriceRecalculation) {
      let basePrice = 0;
      const noOfNights = +calNoOfNights(range.startDate, range.endDate);
      const currentRatePlan =
        selectedRoomPlan.rate_amount ||
        bookingInfo?.room_booking?.[0]?.rate_plan_amount ||
        0;
      roomInfoBasedOnAdult?.rooms?.forEach((singleRoomInfo: any) => {
        if (selectedRoomType.id === singleRoomInfo?.room_type_id) {
          basePrice = singleRoomInfo?.room_price?.total_price;
        }
      });
      const totalPrice =
        basePrice + currentRatePlan * Number(noOfAdult) * noOfNights;
      setOriginalPrice(totalPrice);
      setNeedsPriceRecalculation(false);
      setPriceCalculationTrigger((prev) => prev + 1);
    } else {
      setSubmitButtonType("update");
      const form = document.querySelector("form");
      if (form) {
        const submitEvent = new Event("submit", {
          cancelable: true,
          bubbles: true,
        });
        form.dispatchEvent(submitEvent);
      }
    }
  };

  useEffect(() => {
    console.log("this is e lafda effect");

    getRoomRatePlan({
      hotel_code: loggedUser?.hotel_code,
      room_type_id:
        selectedEventInfo.event._def.extendedProps.guestBasicInfo?.room_type_id,
    }).then((response: any) => {
      setRoomRatePlan(response?.data);

      if (
        selectedEventInfo.event._def.extendedProps.guestBasicInfo?.rate_plan_id
      ) {
        const match: any = response.data.find(
          (plan: any) =>
            plan.id ===
            selectedEventInfo.event._def.extendedProps.guestBasicInfo
              ?.rate_plan_id,
        );

        if (match) {
          setRateType(match?.name);
          setSelectedRoomPlan(match);
        }
      }
    });
    getRoomTypeList(loggedUser?.hotel_code, 1);
    const payload = {
      hotel_code: loggedUser?.hotel_code,
      start_date: formateDateInApiSupport(range.startDate),
      end_date: formateDateInApiSupport(range.endDate),
      room_info: [
        {
          number_of_adults: +noOfAdult,
          number_of_children: +noOfChild,
          number_of_children_0_6: 0,
          number_of_children_6_12: 0,
        },
      ],
    };
    getRoomInformationData(payload).then((roomInformationData: any) => {
      setRoomInfoBasedOnAdult(roomInformationData.data);
    });
    onRoomTypeSelected(selectedRoomType?.id);
  }, [selectedEventInfo.event._def.extendedProps.guestBasicInfo?.room_type_id]);

  useEffect(() => {
    const body = {
      from_date: formateDateInApiSupport(range.startDate),
      to_date: formateDateInApiSupport(range.endDate),
      pms_hotel_code: loggedUser?.hotel_code,
      room_type_id: selectedRoomType.id,
    };

    getEmptyRoomNumber(body)
      .then((response) => {
        setEmptyRoom(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [selectedRoomType.id]);

  useEffect(() => {
    if (
      selectedRoom.id &&
      !emptyRoom.some((room: any) => room.id === Number(selectedRoom.id))
    ) {
      const assignedRoom = {
        id: Number(selectedRoom.id),
        room_name: roomInfo?.room_name || "Assigned Room",
      };
      setEmptyRoom((prev: any) => [assignedRoom, ...prev]);
    }
  }, [emptyRoom, selectedRoom.id, bookingInfo, roomInfo]);

  useEffect(() => {
    const priceObj = findRoomInfoAndSetPrice(
      roomInfoBasedOnAdult,
      {
        discountMethod: calculatedPrice.discountMethod,
        discountValue: calculatedPrice.discountValue,
      },
      initBookingData,
      originalPrice,
      calendarInfo,
    );
    setCalcualtedPrice({
      ...calculatedPrice,
      ...priceObj,
    });
    console.log("After Calculate Price click, calculatedPrice set to:", {
      ...calculatedPrice,
      ...priceObj,
    });
  }, [originalPrice, calculatedPrice.discountValue, priceCalculationTrigger]);

  useEffect(() => {
    if (calculatedPrice.total_tax <= 0) {
      setChecked(false);
    } else {
      setChecked(
        calculatedPrice.total_price_with_tax >
          calculatedPrice.total_without_tax,
      );
    }
  }, [
    calculatedPrice.total_tax,
    calculatedPrice.total_price_with_tax,
    calculatedPrice.total_without_tax,
  ]);

  useEffect(() => {
    const roomInfo = resourceMap[selectedEventInfo.event._def.resourceIds[0]];
    const bookingId = selectedEventInfo.event.title.split("_")[0];
    setRoomInfo(roomInfo);
    setBookingId(bookingId);
    getAndSetBookingInfo(bookingId);
  }, [selectedEventInfo]);
  useEffect(() => {
    onRoomTypeSelected(selectedRoomType?.id);
  }, [range.startDate, range.endDate]);
  useEffect(() => {
    if (bookingInfo?.corporate_id) {
      setMarketSegment("Corporate");
      setSelectedCorporate(bookingInfo?.corporate_id);
      getCorporateData(loggedUser?.hotel_code, 0).then((res) =>
        setData(res.data),
      );
    } else if (bookingInfo?.travel_agent_id) {
      setMarketSegment("Travel Agent");
      getTravelAgentData(loggedUser?.hotel_code, 0).then((res) =>
        setData(res.data),
      );
    } else if (bookingInfo?.market_segment) {
      setMarketSegment(bookingInfo.market_segment);
    }

    if (bookingInfo?.rete_plan_name) {
      setRateType(
        bookingInfo.rete_plan_name.split(" ")?.[0] ||
          bookingInfo.rete_plan_name,
      );
    } else if (
      bookingInfo?.room_booking?.[0]?.rate_plan_id &&
      roomRatePlan?.length
    ) {
      const matchedPlan = roomRatePlan.find(
        (plan) => plan.id === bookingInfo.room_booking[0].rate_plan_id,
      );
      if (matchedPlan) {
        setRateType(matchedPlan.name);
        setSelectedRoomPlan(matchedPlan);
      }
    }
  }, [bookingInfo, roomRatePlan]);

  const elements = [] as any;
  for (let i = 2; i <= noOfAdult; i++) {
    elements.push(
      <>
        <FormGroup className="edit-form-group">
          <Field
            name={`firstName${i}`}
            className="edit-form-input"
            placeholder="Enter First Name(extra)"
            type="text"
          />
          <p className="edit-form-error">
            <ErrorMessage name="firstName" />
          </p>
        </FormGroup>
        <FormGroup className="edit-form-group">
          <Field
            name={`lastName${i}`}
            className="edit-form-input"
            placeholder="Enter Last Name"
            type="text"
          />
          <p className="edit-form-error">
            <ErrorMessage name="lastName" />
          </p>
        </FormGroup>
      </>,
    );
  }

  if (selectedEventInfo) {
    return (
      <Box className="edit-form-container">
        {isOpen && (
          <div className="edit-form-modal-overlay">
            <div className="edit-form-modal-container">
              <div className="edit-form-modal-content">
                <div className="edit-form-modal-body">
                  <h3 className="edit-form-modal-title">
                    Are you sure to mark the guest as No Show?
                  </h3>
                  <div className="mt-4">
                    <label htmlFor="reason" className="edit-form-label">
                      Reason:
                    </label>
                    <input
                      type="text"
                      id="reason"
                      name="reason"
                      value={reason}
                      onChange={handleReasonChange}
                      className={`edit-form-modal-input ${
                        error ? "edit-form-modal-input-error" : ""
                      }`}
                    />
                    {error && <p className="edit-form-error">{error}</p>}
                  </div>
                </div>
                <div className="edit-form-modal-footer">
                  <button
                    onClick={handleConfirm}
                    type="button"
                    className="edit-form-modal-confirm"
                  >
                    Yes
                  </button>
                  <button
                    onClick={closeModal}
                    type="button"
                    className="edit-form-modal-cancel"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <Paper elevation={0} className="edit-form-header-paper">
          <Box className="edit-form-header-section">
            <Typography className="edit-form-header-title">
              Edit Reservation
            </Typography>
          </Box>

          <Box className="edit-form-header-details-container">
            <Box className="edit-form-header-detail-item">
              <Typography className="edit-form-header-label edit-form-nowrap">
                Booking Id:
              </Typography>
              <Typography className="edit-form-header-value edit-form-nowrap">
                {bookingId}
              </Typography>
            </Box>

            {/* <Box className="edit-form-header-detail-item">
              <Typography className="edit-form-header-label edit-form-nowrap">
                Voucher:
              </Typography>
              <a
                href={`${baseUrl}/booking_pdf_pms?booking_id=${bookingInfo.booking_id}&customer_id=${bookingInfo.customer_id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="edit-form-header-link edit-form-nowrap"
              >
                Click Here
              </a>
            </Box> */}

            <Box className="edit-form-header-detail-item">
              <Typography className="edit-form-header-label edit-form-nowrap">
                Source:
              </Typography>
              <Typography className="edit-form-header-value edit-form-nowrap">
                {bookingInfo?.booking_from === "Booking"
                  ? "Booking.com"
                  : bookingInfo?.booking_from}
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Formik
          initialValues={defaultValues}
          validationSchema={formValidation}
          // onSubmit={(event) => handleSubmit(event)}
          onSubmit={handleSubmit}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <Box className="edit-form-container-inner">
                <Box className="edit-form-grid">
                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">Duration</label>
                    <div className="edit-form-date-range">
                      {bookingInfo.booking_status === "check_in" ? (
                        <DateRangeComponent
                          range={range}
                          onSetRange={onSetRange}
                          isShowPastDate={false}
                          startFalse={true}
                        />
                      ) : (
                        <DateRangeComponent
                          range={range}
                          onSetRange={onSetRange}
                          isShowPastDate={false}
                          startFalse={false}
                        />
                      )}
                    </div>
                  </FormGroup>
                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">Room type</label>
                    <Field
                      as="select"
                      className="edit-form-select"
                      name="roomType"
                      onChange={(e: any) => onRoomTypeSelected(e.target.value)}
                      value={selectedRoomType.id}
                    >
                      <option value="">select</option>
                      {roomTypeList.map((roomType: any, key: any) => (
                        <option value={roomType.id} key={key}>
                          {roomType.room_type_name}
                        </option>
                      ))}
                    </Field>
                    <p className="edit-form-error">
                      <ErrorMessage name="roomType" />
                    </p>
                  </FormGroup>
                </Box>

                <Box className="edit-form-grid">
                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      Rate Type<span className="required-star">*</span>
                    </label>
                    <Field
                      as="select"
                      className="edit-form-select"
                      name="rateType"
                      onChange={(e: any) => {
                        handleOnchangePlan(e.target.value);
                        setRateType(e.target.value);
                      }}
                      value={rateType}
                    >
                      <option value={""}>Select</option>
                      {roomRatePlan?.map((plan: any) => (
                        <option value={plan?.name} key={plan?.id}>
                          {plan?.name}
                        </option>
                      ))}
                    </Field>
                    <p className="edit-form-error">
                      <ErrorMessage name="rateType" />
                    </p>
                  </FormGroup>

                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      Room No <span className="required-star">*</span>
                    </label>
                    <Field
                      as="select"
                      className="edit-form-select"
                      name="room"
                      value={selectedRoom.id}
                      onChange={(e: any) => {
                        onRoomSelected(+e.target.value);
                        setRoomSelectionError("");
                      }}
                    >
                      <option value={""}>select</option>
                      {emptyRoom?.map((room: any, key: any) => (
                        <option value={room.id} key={key}>
                          {room.room_name}
                        </option>
                      ))}
                    </Field>
                    <p className="edit-form-error">
                      <ErrorMessage name="child" />
                      {roomSelectionError && (
                        <span style={{ color: "#dc2626" }}>
                          {roomSelectionError}
                        </span>
                      )}
                    </p>
                  </FormGroup>
                </Box>

                <Box className="edit-form-grid">
                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">Adult</label>
                    <Field
                      as="select"
                      className="edit-form-select"
                      name="adult"
                      onChange={(e: any) => onNoOfAdultlChange(e.target.value)}
                      value={noOfAdult}
                    >
                      <option value="">Select</option>
                      {Array.from(
                        {
                          length:
                            roomTypeList.find(
                              (rt: any) => rt.id === selectedRoomType.id,
                            )?.higher_occupancy ||
                            roomTypeList.find(
                              (rt: any) => rt.id === selectedRoomType.id,
                            )?.base_occupancy ||
                            3,
                        },
                        (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ),
                      )}
                    </Field>
                    <p className="edit-form-error">
                      <ErrorMessage name="adult" />
                    </p>
                  </FormGroup>

                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">Child</label>
                    <Field
                      as="select"
                      className="edit-form-select"
                      name="child"
                      onChange={(e: any) =>
                        onNoOfAdultlChange(e.target.value, {}, "child")
                      }
                      value={noOfChild}
                    >
                      <option value="">0</option>
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                    </Field>
                    <p className="edit-form-error">
                      <ErrorMessage name="child" />
                    </p>
                  </FormGroup>
                </Box>

                <Box className="edit-form-grid">
                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      First Name<span className="required-star">*</span>
                    </label>
                    <Field
                      name="firstName"
                      className="edit-form-input"
                      placeholder="Enter First Name"
                      type="text"
                    />
                    <p className="edit-form-error">
                      <ErrorMessage name="firstName" />
                    </p>
                  </FormGroup>

                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">Last Name</label>
                    <Field
                      name="lastName"
                      className="edit-form-input"
                      placeholder="Enter Last Name"
                      type="text"
                    />
                    <p className="edit-form-error">
                      <ErrorMessage name="lastName" />
                    </p>
                  </FormGroup>
                </Box>

                {/* <Box className="edit-form-grid">
                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      Market Segment
                    </label>
                    <Field
                      as="select"
                      className="edit-form-select"
                      name="market_segment"
                      value={marketSegment}
                      onChange={fetchSegmentData}
                    >
                      <option value="">Select</option>
                      <option value="Corporate">Corporate</option>
                      <option value={"Travel Agent"}>Travel Agent</option>
                      <option value={"Walk Inn"}>Walk Inn</option>
                      <option value={"Wedding"}>Wedding</option>
                      <option value={"Events"}>Events</option>
                      <option value={"Leisure"}>Leisure</option>
                    </Field>
                    <p className="edit-form-error">
                      <ErrorMessage name="Type" />
                    </p>
                  </FormGroup>

                  {marketSegment === "Corporate" ? (
                    <FormGroup className="edit-form-group">
                      <label className="edit-form-label">
                        Corporate
                      </label>
                      <Field
                        as="select"
                        className="edit-form-select"
                        name="corporate_id"
                        value={selectedCorporate}
                        onChange={handleCorporateChange}
                      >
                        <option value="">Select</option>
                        {data.length > 0 &&
                          data.map((item: any) => (
                            <option value={item?.id} key={item?.id}>
                              {item?.corporate_name}
                            </option>
                          ))}
                      </Field>
                    </FormGroup>
                  ) : marketSegment === "Travel Agent" ? (
                    <FormGroup className="edit-form-group">
                      <label className="edit-form-label">
                        Travel Agent
                      </label>
                      <Field 
                        as="select" 
                        className="edit-form-select"
                        name="travel_agent_id"
                      >
                        <option value="">Select</option>
                        {data.length > 0 &&
                          data.map((item: any) => (
                            <option value={item?.id} key={item?.id}>
                              {item?.billing_company_name}
                            </option>
                          ))}
                      </Field>
                    </FormGroup>
                  ) : null}
                </Box> */}

                <Box className="edit-form-grid">
                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      Email<span className="required-star">*</span>
                    </label>
                    <Field
                      name="email"
                      className="edit-form-input"
                      placeholder="Enter Email id"
                      type="email"
                      autoComplete="email"
                    />
                    <p className="edit-form-error">
                      <ErrorMessage name="email" />
                    </p>
                  </FormGroup>

                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      Mobile<span className="required-star">*</span>
                    </label>
                    <Field
                      name="mobileNumber"
                      className="edit-form-input"
                      placeholder="Enter Mobile no*"
                      type="tel"
                      inputMode="numeric"
                      pattern="[0-9]{10}"
                      maxLength={10}
                      autoComplete="tel"
                      onInput={(e: any) => {
                        const input = e.target as HTMLInputElement;
                        input.value = input.value.replace(/[^0-9]/g, "");
                      }}
                    />
                    <p className="edit-form-error">
                      <ErrorMessage name="mobileNumber" />
                    </p>
                  </FormGroup>
                </Box>

                <Box className="edit-form-grid">
                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      Price{" "}
                      <span className="edit-form-text-sm edit-form-text-normal">
                        (
                        {calNoOfNights(range.startDate, range.endDate) > 1
                          ? `${calNoOfNights(
                              range.startDate,
                              range.endDate,
                            )} nights`
                          : `${calNoOfNights(
                              range.startDate,
                              range.endDate,
                            )} night`}
                        )
                      </span>
                    </label>
                    <Field
                      name="price1"
                      className="edit-form-input"
                      placeholder="Enter Base Price*"
                      onChange={(e: any) => setOriginalPrice(+e.target.value)}
                      value={originalPrice}
                      type="number"
                    />
                  </FormGroup>

                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      Final Price{" "}
                      <span className="edit-form-text-sm edit-form-text-normal">
                        (Incl. tax & svc. charge)
                      </span>
                    </label>
                    <Field
                      name="price"
                      className="edit-form-input"
                      value={
                        checked
                          ? calculatedPrice.total_price_with_tax
                          : calculatedPrice.total_without_tax
                      }
                      type="number"
                    />
                  </FormGroup>
                </Box>

                {/* <Box>
                  <FormGroup className="edit-form-group">
                    <Button
                      type="button"
                      className="edit-form-button edit-form-button-calculate"
                      onClick={() => handleCalculateNewPrice()}
                    >
                      Calculate Price
                    </Button>
                  </FormGroup>
                </Box> */}

                {/* <Box>
                  <FormGroup className="edit-form-group">
                    <Button
                      type="button"
                      className={`edit-form-button edit-form-button-calculate ${
                        needsPriceRecalculation ? 'edit-form-button-calculate-pending' : ''
                      }`}
                      onClick={() => handleCalculateNewPrice()}
                    >
                      Calculate Price
                      {needsPriceRecalculation}
                    </Button>
                    {needsPriceRecalculation && (
                      <Typography 
                        className="edit-form-recalculation-warning"
                        variant="body2" 
                        color="warning.main"
                      >
                        Prices need to be recalculated after recent changes
                      </Typography>
                    )}
                  </FormGroup>
                </Box> */}

                {/* <Box className="edit-form-grid">
                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      Discount Method
                    </label>
                    <Field
                      as="select"
                      className="edit-form-select"
                      name="discountMethod"
                    >
                      <option value="">Select</option>
                      <option value={"Percentage"}>Percentage</option>
                      <option value={"Amount"}>Amount</option>
                    </Field>
                    <p className="edit-form-error">
                      <ErrorMessage name="adult" />
                    </p>
                  </FormGroup>

                  <FormGroup className="edit-form-group">
                    <label className="edit-form-label">
                      Percentage/Amount
                    </label>
                    <Field
                      name="discountValue"
                      className="edit-form-input"
                      placeholder="Enter Percentage/Amount if any"
                      type="number"
                      onBlur={(e: any) => {
                        setCalcualtedPrice((prev: any) => ({
                          ...prev,
                          discountValue: +e.target.value,
                          discountMethod: values.discountMethod,
                        }));
                      }}
                    />
                    <p className="edit-form-error">
                      <ErrorMessage name="partialPayment" />
                    </p>
                  </FormGroup>
                </Box> */}

                <Box className="edit-form-grid">
                  {/* <FormGroup className="edit-form-group edit-form-flex-center">
                    <FormControlLabel
                      control={
                        <Switch
                          checked={checked}
                          onChange={handleChange}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                      label="Price Inc Tax"
                    />
                  </FormGroup> */}
                </Box>

                {/* <Box className="edit-form-button-grid">
                  <Button
                    disabled={!noOfAdult || bookingInfo.booking_status === "check_out"}
                    type="submit"
                    className="edit-form-button edit-form-button-update"
                    onClick={() => setSubmitButtonType("update")}
                  >
                    Update
                  </Button>
                  <Button
                    type="submit"
                    disabled={bookingInfo.booking_status === "check_in" || bookingInfo.booking_status === "check_out"}
                    className="edit-form-button edit-form-button-cancel"
                    onClick={() => setSubmitButtonType("cancelReservation")}
                  >
                    Cancel Reservation
                  </Button>
                </Box> */}

                <Box className="edit-form-button-grid">
                  <Button
                    disabled={
                      !noOfAdult ||
                      bookingInfo.booking_status === "check_out" ||
                      isSubmitting
                    }
                    type="button"
                    className={`edit-form-button ${
                      needsPriceRecalculation
                        ? "edit-form-button-update"
                        : "edit-form-button-update"
                    }`}
                    onClick={handleCalculateAndUpdate}
                  >
                    {needsPriceRecalculation ? (
                      <>
                        Calculate Price
                        <span className="edit-form-recalculation-indicator">
                          {" "}
                          *
                        </span>
                      </>
                    ) : (
                      "Update"
                    )}
                  </Button>

                  <Button
                    type="submit"
                    disabled={
                      bookingInfo.booking_status === "check_in" ||
                      bookingInfo.booking_status === "check_out" ||
                      needsPriceRecalculation || // Disable if prices need recalculation
                      isSubmitting
                    }
                    className="edit-form-button edit-form-button-cancel"
                    onClick={() => setSubmitButtonType("cancelReservation")}
                  >
                    Cancel Reservation
                  </Button>
                </Box>

                {needsPriceRecalculation && (
                  <Box className="edit-form-recalculation-warning-container">
                    <Typography
                      className="edit-form-recalculation-warning"
                      variant="body2"
                      color="warning.main"
                    >
                      Prices need to be recalculated after recent changes. Click
                      "Calculate Price" to update prices.
                    </Typography>
                  </Box>
                )}

                {bookingInfo.booking_status === "pending" &&
                isEqualOrAfter(
                  moment().startOf("day"),
                  selectedEventInfo.event.start,
                ) ? (
                  <Box className="edit-form-button-row">
                    <Button
                      type="submit"
                      className="edit-form-button edit-form-button-checkin"
                      onClick={() => setSubmitButtonType("checkin")}
                    >
                      Check In
                    </Button>
                    <Button
                      type="button"
                      className="edit-form-button edit-form-button-noshow"
                      onClick={openModal}
                    >
                      No Show
                    </Button>
                  </Box>
                ) : null}
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    );
  } else {
    return <p>Sorry something wrong</p>;
  }
};

export default DemoEdit;
